import { createFilledIcon } from "../createIcon";

export const BellFilledIcon = createFilledIcon(
  <>
    <path d="M4.203 18.618h15.715a.57.57 0 0 0 .582-.555v-.58a.544.544 0 0 0-.174-.395l-1.69-1.588a.544.544 0 0 1-.173-.396V8.908c0-2.656-2.168-4.829-4.906-4.993-.183-.01-.332-.152-.332-.327v-.476c0-.614-.522-1.112-1.165-1.112s-1.164.498-1.164 1.112v.476c0 .175-.149.316-.332.327-2.738.164-4.906 2.337-4.906 4.992v6.197a.544.544 0 0 1-.174.396l-1.69 1.588a.544.544 0 0 0-.173.396v.579c0 .306.26.555.582.555ZM12.06 22.2c1.367 0 2.514-.8 2.826-1.878.093-.318-.184-.592-.515-.592H9.75c-.332 0-.609.274-.517.592.313 1.078 1.46 1.878 2.826 1.878Z" />
  </>,
  "BellFilledIcon"
);
